import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import site from './modules/site';
import service from './modules/service';
import order from './modules/order';
import upload from './modules/upload';
import message from './modules/message';
import country from './modules/country';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    site,
    auth,
    service,
    order,
    upload,
    message,
    country,
  },
});
